<template>
  <div class="modal sign-modal reg-modal">
    <div class="overlay" @click="$emit('closeSignUp')" />
    <div class="wrapper">
      <button class="close" @click="$emit('closeSignUp')">
        <img src="@/assets/img/closeNew.svg" alt="close new" srcset="" />
      </button>

      <div class="modal-content">
        <div class="container">
          <div class="form">
            <div class="form-wrapper">
              <div class="modal-main">
                <div class="form-fields register-content">
                  <div class="form-fields-wrapper">
                    <div class="auth-left">
                      <div class="title desc-bottom">
                        <span class="text-white"
                          >{{ $t("Already have an account?") }}
                        </span>
                        <button
                          class="button bordered-white w-130"
                          @click="$emit('openSignIn')"
                        >
                          {{ $t("Sign in") }}
                        </button>
                      </div>
                    </div>

                    <div class="auth-right">
                      <div class="title text-white">{{ $t("Sign Up") }}</div>
                      <label>
                        <input
                          v-model="name"
                          type="text"
                          :placeholder="$t('First name')"
                        />
                      </label>
                      <label>
                        <input
                          v-model="surname"
                          type="text"
                          :placeholder="$t('Last name')"
                        />
                      </label>

                      <label>
                        <input
                          v-model="email"
                          type="email"
                          :placeholder="$t('Email')"
                        />
                      </label>
                      <label>
                        <MazPhoneNumberInput
                          :autoFormat="false"
                          v-model="phone"
                          v-model:country-code="countryCode"
                          @update:countryCode="countryCode = $event"
                          show-code-on-list
                          :only-countries="countryOptionsIso"
                          country-locale="en-EN"
                          @update="phoneDataUpdate($event)"
                          :placeholder="$t('Phone number')"
                        />
                      </label>
                      <label>
                        <input
                          v-model="pass"
                          type="password"
                          :placeholder="$t('Password')"
                        />
                      </label>
                      <label>
                        <input
                          v-model="passConfirm"
                          type="password"
                          :placeholder="$t('Confirm Password')"
                        />
                      </label>

                      <div class="container-bottom">
                        <label class="checkbox-label">
                          <div class="checkbox-label-wrapper">
                            <input type="checkbox" v-model="terms" />
                            <div class="checkbox"></div>

                            <span class="desc small">
                              {{ $t("By signing up you agree to our") + " " }}
                            </span>
                            <router-link
                              v-if="termsPage"
                              :to="`/pages/${termsPage.id}`"
                              class="desc small"
                              target="_blank"
                            >
                              {{ termsPage.title }}
                            </router-link>
                            <template v-if="termsPage && privacyPage">
                              <span class="desc small">
                                {{ " " + $t("and") + " " }}
                              </span>
                              <router-link
                                :to="`/pages/${privacyPage.id}`"
                                class="desc small"
                                target="_blank"
                              >
                                {{ privacyPage.title }}
                              </router-link>
                            </template>
                          </div>
                        </label>
                      </div>

                      <div class="cta-container">
                        <button
                          :disabled="
                            !requiredRegisterFieldsAreFilled || loaderIsVisible
                          "
                          @click="submitRegister"
                          class="button red w-130"
                        >
                          {{ $t("Sign up") }}
                        </button>
                      </div>

                      <Transition>
                        <div v-if="error" class="error-desc desc red">
                          {{ error }}
                        </div>
                      </Transition>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { TERMS_PAGE, PRIVACY_PAGE } from "@/store/modules/staticPages";

export default {
  name: "RegistrationModal",
  props: {
    error: {
      type: String,
      required: true,
    },
    loaderIsVisible: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      email: "",
      pass: "",
      name: "",
      surname: "",
      phone: "",
      passConfirm: "",
      terms: false,
      countryCode: "",
      phoneFull: "",
      countryOptions: [],
      countryOptionsIso: [],
      dob: null,
      address: "",
      city: "",
      zip: "",
      countryId: "",
      referralCode: "",
    };
  },
  computed: {
    ...mapGetters("staticPages", ["getTermsPage", "getPrivacyPage"]),
    termsPage() {
      return this.getTermsPage;
    },
    privacyPage() {
      return this.getPrivacyPage;
    },
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name &&
        this.surname &&
        this.phone &&
        this.email &&
        // this.dob &&
        this.pass &&
        this.passConfirm &&
        this.terms
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  created() {
    this.TERMS_PAGE = TERMS_PAGE;
    this.PRIVACY_PAGE = PRIVACY_PAGE;
  },
  mounted() {
    this.getCountries();
  },
  methods: {
    clearCountry() {
      this.countryId = "";
    },
    phoneDataUpdate(e) {
      this.phoneFull = e.phoneNumber; // Use raw phoneNumber without formatting
    },
    getCountries() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
          this.countryOptionsIso = res.data.payload.map((obj) => obj.iso);
          this.countryCode = this.countryOptionsIso[0];
        })
        .catch(() => {});
    },
    closeSignUpModal() {
      this.$emit("closeSignIn");
    },
    openSignInModal() {
      this.$emit("openSignIn");
    },
    submitRegister() {
      let regData = {
        dob: this.dob,
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phoneFull,
        password: this.pass,
        passConfirm: this.passConfirm,
        address: this.address,
        city: this.city,
        zip: this.zip,
        country_id: this.countryId,
        referral_code: this.referralCode,
      };
      this.$emit("registration", regData);
    },
    showDatePicker() {
      this.$refs.dob.type = "date";
      this.$refs.dob.focus();
    },
    hideDatePicker() {
      if (!this.dob) {
        this.$refs.dob.type = "text";
        this.dob = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container-wrapper {
  border: 1px solid #191919;
  padding: 12px;
  position: relative;
  max-width: 441.6px;
  width: 100%;
}

.modal .container {
  padding: 0;
  flex-direction: column;
  padding: 32px 16px;
}

.container-bottom {
  margin: 16px auto 0;
  text-align: left;

  .cta-container {
    margin-top: 12px;
  }
}

.title + label {
  margin-top: 34px;
}
</style>
